import styled from 'styled-components';

import { Title } from '@atom/typography/typography';

export const LeftTitle = styled(Title).attrs((props) => ({
  level: 4,
  color: props.theme.Title.colorNavAuthTitle,
}))`
  padding-top: 24px;
  padding-left: 2px;
`;
